import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.replace("#", ""));
      const scrollToHashTarget = () => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
          return;
        }
        window.scrollTo(0, 0);
      };

      requestAnimationFrame(scrollToHashTarget);
      return;
    }

    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
